<template lang="pug">
  .wrap(v-if="company")
    .sidebar.sidebar-company-show(:class="{ 'sidebar-fixed-sp': this.sidebarHidden }")
      .return-prev(v-if="fromMap")
        // a(@click="back") MAPに戻る
      .return-prev(v-else-if="fromJob")
        a(@click="back") 求人検索に戻る
      .return-prev(v-else)
        // a(@click="back") 事業所検索に戻る
      h4 事業所情報
      ul
        li
          a(@click="pageScroll('company-show-section1')") 基本情報
        li
          a(@click="pageScroll('company-show-section2')") 電話番号
        li
          a(@click="pageScroll('company-show-section3')") 出稿予算・掲載状況
        li(v-if="company.in_job_mark")
          a(@click="pageScroll('company-show-section4')") コメント
    .main
      .company-show
        .company-show-header
          .point
            span.label(v-for="p in company.pr_point") {{ p }}
          h2.company_name
            | {{ company.company_name }}
          .company_url
            a(:href="company.company_url" target="_blank" rel="noopener noreferrer")
              | {{ company.company_url }}
        .company-show-body
          .company-show-section#company-show-section1
            h3 基本情報
              span 取得日：{{ company.acquisition_date }}
            .row
              .col.title
                | 事業所ID
              .col
                | {{ company.company_id }}&nbsp;
                a.button-sub.company_id_job(
                  :href="company.master_url"
                  target="_blank"
                  rel="noopener noreferrer")
                  | すべての求人を見る
            .row
              .col.title
                | 住所
              .col
                a.button-sub(
                  :href="googleMapUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  v-if="googleMapUrl")
                  | 拡大地図を表示
                span(v-html="companyPlaceWithLineBreak") &nbsp;
            .row
              .col.title
                | アクセス情報
              .col
                span(v-html="company.company_access") &nbsp;
            .row
              .col.title
                | 業種
              .col
                span(v-for="i in company.industry")
                  | {{ i }}
                  br
                | &nbsp;
            .row
              .col.title
                | 事業内容
              .col
                span(v-html="company.company_contents") &nbsp;
            .row
              .col-wrap
                .col.title
                  | 従業員数
                .col
                  | {{ company.employee_amount }}&nbsp;
                .col.title
                  | 設立
                .col
                  | {{ company.established }}&nbsp;
            .row
              .col-wrap
                .col.title
                  | 売上高
                .col
                  | {{ company.sales }}&nbsp;
                .col.title
                  | 資本金
                .col
                  | {{ company.capital }}&nbsp;
            .row
              .col-wrap
                .col.title
                  | 代表
                .col
                  | {{ company.president_name }}&nbsp;
                .col.title
                  | FAX
                .col
                  | {{ company.fax }}&nbsp;
            .row
              .col-wrap
                .col.title
                  | 採用担当
                .col
                  span(
                    v-if="company.recruiting_personnel"
                    v-html="company.recruiting_personnel.join('、')"
                  )
                  span(v-if="company.hw_date")
                    | {{ `（${company.hw_date}時点）` }}
                  | &nbsp;
                .col.title
                  | メールアドレス
                .col
                  span(v-if="company.mail_address" v-html="company.mail_address.join('<br/>')")
            .row
              .col.title
                | ブランド
              .col
                | {{ company.brand }}&nbsp;
          .company-show-section#company-show-section2
            h3 電話番号
              span 更新日：{{ company.updated_date }}
            .row
              .col-wrap
                .col.title
                  | 総合判定
                .col
                  a.company_tel(:href="telLink" v-if="company.company_tel")
                    | {{ company.company_tel }}
                  | &nbsp;
                .col.title
                  | 当社調べ
                .col
                  | {{ company.company_manual_tel }}&nbsp;
            .row(v-for="tels in groupedComputerMediaTels")
              .col-wrap
                template(v-for="t in tels")
                  .col.title
                    | {{ t.media }}
                  .col
                    | {{ t.tel }}

          .company-show-section#company-show-section3
            h3 出稿予算・掲載状況
              span
                a.button-sub(:href="company.master_url" target="_blank" rel="noopener noreferrer")
                  | すべての求人を見る
            .company-published-description
              | 当システムでは「中途メディアデータ：2018年5月〜」「APメディアデータ：2018年7月〜」を保有しております。
            h4 中途
            table.table
              tr
                th &nbsp;
                th 今月
                th
                  | 先月
                  br
                  span
                    | {{ this.getLastMonth() }}
                th
                  | 3ヶ月
                  br
                  span
                    | {{ this.getPeriodMonths(3) }}
                th
                  | 6ヶ月
                  br
                  span
                    | {{ this.getPeriodMonths(6) }}
                th
                  | 1年
                  br
                  span
                    | {{ this.getPeriodMonths(12) }}
              tr
                td.left 出稿予算
                td {{ company.budget_recruit_current_month }}<br class="only-sp" />万円
                td {{ company.budget_recruit_last_month }}<br class="only-sp" />万円
                td {{ company.budget_recruit_last_quarter }}<br class="only-sp" />万円
                td {{ company.budget_recruit_last_harf_year }}<br class="only-sp" />万円
                td {{ company.budget_recruit_last_year }}<br class="only-sp" />万円
              tr
                td.left 掲載状況
                td
                  | {{ company.published_jobs_recruit_media_current_month }}
                  <br class="only-sp" />求人
                td
                  | {{ company.published_jobs_recruit_media_last_month }}
                  <br class="only-sp" />求人
                td
                  | {{ company.published_jobs_recruit_media_last_quarter }}
                  <br class="only-sp" />求人
                td
                  | {{ company.published_jobs_recruit_media_harf_year }}
                  <br class="only-sp" />求人
                td
                  | {{ company.published_jobs_recruit_media_year }}
                  <br class="only-sp" />求人
              tr
                td.left 出稿<br class="only-sp" />メディア
                td
                  ul
                    li(v-for="m in company.published_recruit_media_name_current_month") {{ m }}
                td
                  ul
                    li(v-for="m in company.published_recruit_media_name_last_month") {{ m }}
                td
                  ul
                    li(v-for="m in company.published_recruit_media_name_last_quarter") {{ m }}
                td
                  ul
                    li(v-for="m in company.published_recruit_media_name_harf_year") {{ m }}
                td
                  ul
                    li(v-for="m in company.published_recruit_media_name_year") {{ m }}
            h4 AP
            table.table
              tr
                th &nbsp;
                th 今月
                th
                  | 先月
                  br
                  span
                    | {{ this.getLastMonth() }}
                th
                  | 3ヶ月
                  br
                  span
                    | {{ this.getPeriodMonths(3) }}
                th
                  | 6ヶ月
                  br
                  span
                    | {{ this.getPeriodMonths(6) }}
                th
                  | 1年
                  br
                  span
                    | {{ this.getPeriodMonths(12) }}
              tr
                td.left 出稿予算
                td {{ company.budget_ap_current_month }}<br class="only-sp" />万円
                td {{ company.budget_ap_last_month }}<br class="only-sp" />万円
                td {{ company.budget_ap_last_quarter }}<br class="only-sp" />万円
                td {{ company.budget_ap_last_harf_year }}<br class="only-sp" />万円
                td {{ company.budget_ap_last_year }}<br class="only-sp" />万円
              tr
                td.left 掲載状況
                td
                  | {{ company.published_jobs_ap_media_current_month }}
                  <br class="only-sp" />求人
                td
                  | {{ company.published_jobs_ap_media_last_month }}
                  <br class="only-sp" />求人
                td
                  | {{ company.published_jobs_ap_media_last_quarter }}
                  <br class="only-sp" />求人
                td
                  | {{ company.published_jobs_ap_media_harf_year }}
                  <br class="only-sp" />求人
                td
                  | {{ company.published_jobs_ap_media_year }}
                  <br class="only-sp" />求人
              tr
                td.left 出稿<br class="only-sp" />メディア
                td
                  ul
                    li(v-for="m in company.published_ap_media_name_current_month") {{ m }}
                td
                  ul
                    li(v-for="m in company.published_ap_media_name_last_month") {{ m }}
                td
                  ul
                    li(v-for="m in company.published_ap_media_name_last_quarter") {{ m }}
                td
                  ul
                    li(v-for="m in company.published_ap_media_name_harf_year") {{ m }}
                td
                  ul
                    li(v-for="m in company.published_ap_media_name_year") {{ m }}


          .company-show-section#company-show-section4(v-if="company.in_job_mark")
            h3 コメント
              span 最終更新者：{{ company.comment_updater }}


            form(@submit.prevent="updateComment")
              textarea(v-model="comment")
              br
              input.button-sub(type="submit" value="コメントを更新する")
    Footer
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { HumanInfoMessages, HumanErrorMessages } from '../constants'
  import mapGetSet from '../libs/map-get-set'
  import company from '../store/modules/company'
  import Footer from './parts/Footer'

  export default {
    components: { Footer },
    data () {
      return {
        sidebarHidden: false,
        fromMap: this.$route.query.from === 'map',
        fromJob: this.$route.query.from === 'job',
        fromHaken: this.$route.query.from === 'haken',
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    beforeMount () {
      if (!this.$store.state.company.detail) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.NO_DATA),
        })
        setTimeout(() => {
          this.$router.go(-1)
        }, 3000)
      }
    },
    async asyncData ({ store, route: { query: { id } } }) {
      if (!id) {
        return
      }
      await store.dispatch('company/fetchDetail', { id })
    },
    computed: {
      ...mapState({
        company: state => state.company.detail,
        comment: state => state.company.comment,
        user: state => state.user.detail,
        meta: state => state.route.meta,
      }),
      ...mapGetters('common', ['spMode']),
      googleMapUrl () {
        if (this.company.company_place_geo) {
          const lat = this.company.company_place_geo.lat
          const lon = this.company.company_place_geo.lon
          return `https://maps.google.com/maps?q=${lat},${lon}`
        }
        if (this.companyPlaceWithoutZipCode) {
          return `https://maps.google.com/maps?q=${this.companyPlaceWithoutZipCode}`
        }
        return ''
      },
      telLink () {
        return `tel:${this.company.company_tel}`
      },
      groupedComputerMediaTels () {
        const result = []
        const base = this.company.company_media_tels
        if (base) {
          const max = Math.ceil(base.length / 2)
          for (let i = 0; i < max; i += 1) {
            const j = i * 2
            result.push(base.slice(j, j + 2))
          }
        }
        return result
      },
      companyPlaceWithLineBreak () {
        if (!this.company.company_place) {
          return ''
        }
        return this.company.company_place.replace(/^(〒[0-9-]+)/g, '$1<br/>')
      },
      companyPlaceWithoutZipCode () {
        if (!this.company.company_place) {
          return ''
        }
        return this.company.company_place.replace(/^(〒[0-9-]+)/g, '')
      },
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.company[k],
        set: ($vm, $s, k, v) => $s.commit(`company/${k}`, v),
        keys: Object.keys(company.state),
      }),
    },
    methods: {
      back () {
        this.$router.go(-1)
      },
      getLastMonth () {
        const now = new Date()
        const last = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        return `(${last.getFullYear() - 2000}/${last.getMonth() + 1})`
      },
      getPeriodMonths (months) {
        const now = new Date()
        const beforeDate = new Date(now.getFullYear(), now.getMonth() - months, 1)
        const before = `${beforeDate.getFullYear() - 2000}/${beforeDate.getMonth() + 1}`
        const afterDate = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        const after = `${afterDate.getFullYear() - 2000}/${afterDate.getMonth() + 1}`
        return `(${before}〜${after})`
      },
      pageScroll (id) {
        document.getElementById(id).scrollIntoView()
      },
      handleScroll () {
        if (this.spMode) {
          this.sidebarHidden = (window.scrollY > 60)
        } else {
          this.sidebarHidden = false
        }
      },
      async updateComment () {
        this.$store.commit('common/lockGlobal')
        const comment = this.comment
        const companyId = this.company.company_id
        const updater = this.user.name
        try {
          await this.$store.dispatch('company/comment', { companyId, comment })
          this.$store.commit('company/updater', { updater })
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.SAVE_COMPANY_COMMENT })
          this.sent = true
        } catch (e) {
          this.sent = false
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/CompanyDetail.vue